import type { KibTagThemes } from '@chewy/kib-tag-react'

import { LabOrdersStatus, LabTestState } from './SOAPStates'

export const ColorNames = {
  BLUE: 'BLUE',
  YELLOW: 'YELLOW',
  GREY: 'GREY',
  GREEN: 'GREEN',
  RED: 'RED',
}

export enum ColorVariant {
  NORMAL = 'normal',
  IMPORTANT = 'important',
  DISABLED = 'disabled',
  SUCCESS = 'success',
  ERROR = 'error',
  NEUTRAL = 'neutral',
}

export const ColorToStatusName = {
  [ColorNames.BLUE]: ColorVariant.NORMAL,
  [ColorNames.YELLOW]: ColorVariant.IMPORTANT,
  [ColorNames.GREY]: ColorVariant.DISABLED,
  [ColorNames.GREEN]: ColorVariant.SUCCESS,
}

export const ColorVariantToTheme: Record<ColorVariant, KibTagThemes> = {
  [ColorVariant.NORMAL]: 'default',
  [ColorVariant.IMPORTANT]: 'caution',
  [ColorVariant.DISABLED]: 'error',
  [ColorVariant.SUCCESS]: 'success',
  [ColorVariant.ERROR]: 'error',
  [ColorVariant.NEUTRAL]: 'neutral',
}

export const LabStatusToColorVariant: Record<string, ColorVariant> = {
  [LabTestState.SELECTED]: ColorVariant.NORMAL,
  [LabTestState.ORDERED]: ColorVariant.NORMAL,
  [LabTestState.PARTIAL_RESULTS]: ColorVariant.NORMAL,
  [LabTestState.IN_PROGRESS]: ColorVariant.NORMAL,
  [LabTestState.UNSUCCESSFUL]: ColorVariant.ERROR,
  [LabTestState.WAITING_ON_SAMPLE]: ColorVariant.IMPORTANT,
  [LabTestState.CANCELLED]: ColorVariant.NEUTRAL,
  [LabTestState.DELETED]: ColorVariant.NEUTRAL,
  [LabTestState.DECLINED]: ColorVariant.NEUTRAL,
  [LabTestState.COMPLETED]: ColorVariant.SUCCESS,
  [LabTestState.RESULTS_RECEIVED]: ColorVariant.SUCCESS,
  [LabOrdersStatus.RESULTS_RECEIVED]: ColorVariant.SUCCESS,
  [LabTestState.UPDATED_RESULTS]: ColorVariant.SUCCESS,
}
